import { Layout } from 'antd';
import PropTypes from 'prop-types';
import { StyleContent } from './style';

function Content(props) {
  const { Content } = Layout;
  const { children } = props;

  return (
    <StyleContent>
      <Content data-testid="content">{children}</Content>
    </StyleContent>
  );
}

Content.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Content;
